import { type ReactNode } from "react";
import { SiteHeader } from "@/components/site-header";
import { MobileTabBar } from "@/components/mobile-tab-bar";
import { FeedbackWidget } from "@/components/feedback-widget";
import { ErrorBoundary } from "@/components/error-boundary";
import { EmailVerificationBanner } from "@/components/email-verification-prompt";

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <SiteHeader />
      <EmailVerificationBanner />
      <main className="min-h-0 flex-1 overflow-auto">
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
      <MobileTabBar />
      <FeedbackWidget />
    </div>
  );
}
